import { StackScreenProps } from '@react-navigation/stack';
import * as React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import Colors from '../constants/Colors';
import FontStyles from '../constants/FontStyle';

import { RootStackParamList } from '../types';

export default function NotFoundScreen({
  navigation,
}: StackScreenProps<RootStackParamList, 'NotFound'>) {
  const buttonHandler = () => {
    const routeNames = navigation.dangerouslyGetState().routeNames
    if (routeNames.includes('Root')) {
      navigation.replace('Root')
    } else {
      navigation.replace('Intro')
    }
  }
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Couldn't find the page you're looking for.</Text>
      <TouchableOpacity onPress={buttonHandler} style={styles.link}>
        <Text style={styles.linkText}>Buy Products</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  title: {
    ...FontStyles.size16,
    ...FontStyles.semibold,
    alignItems: 'center',
    textAlign: 'center',
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    color: Colors.tintColor,
    ...FontStyles.size18,
    ...FontStyles.bold,
    alignItems: 'center',
    textAlign: 'center',
  },
});
